jQuery(function($) {
	initSteps();
});

function initSteps(){
	$('.subscription-steps').subscriptionSteps();
	

}

jQuery(window).on('load', function() {
	var readAllReviewsBtn = $('.review-section .link-u'),
		btnWriteReview = $('.yotpo-regular-box > .write-review-button');

	if(readAllReviewsBtn.length > 0 && btnWriteReview.length > 0) {
		readAllReviewsBtn.insertBefore(btnWriteReview).css({
			'position': 'relative',
			'visibility': 'visible'
		});
	}
});

/*
 * Subscription steps
 */
;(function($) {
	function SubscriptionSteps(opt) {
		this.options = $.extend({
			holder: null,
			steps: '.step',
			btnNext: '.btn-next-step',
			btnPrev: '.btn-prev-step',
			activeClass: 'step-active',
			selectedClass: 'selected',
			subscriptionOptions: '.subscription-option'
		}, opt);
		if (this.options.holder) {
			this.holder = $(this.options.holder);
			this.init();
		}
	}
	SubscriptionSteps.prototype = {
		init: function() {
			this.findElements();
			this.attachEvents();
			this.stepStateHandler();
		},
		findElements: function() {
			var self = this;

			$.cookie.json = true;

			this.steps = this.holder.find(this.options.steps);
			this.btnPrev = this.holder.find(this.options.btnPrev);
			this.btnNext = this.holder.find(this.options.btnNext);
			this.activeIndex = $.cookie('subscriptionSummary') ? $.cookie('subscriptionSummary').stepIndex : 0;
			this.currStep = this.steps.eq(this.activeIndex);
			this.subscriptionOptions = this.holder.find(this.options.subscriptionOptions);
			this.sizesStep = this.steps.filter(':has(.size-options)');
			this.sizeNumber = this.sizesStep.find('.size-quantity').hide();
			this.sizeOptions = this.sizesStep.find('.size-options:not(.multiple) :radio');
			this.multiSizeOptionsHold = this.sizesStep.find('.size-options.multiple');
			this.multiSizeHold = this.holder.find('.size-multiple-variants');
			this.multiSizeFlag = this.subscriptionOptions.filter('[data-multisize]:checked').length > 0 ? this.subscriptionOptions.filter('[data-multisize]:checked').data('multisize') : null;
			this.frequencyOptions = this.holder.find('.frequency-list :radio');
			this.designAllCheckbox = this.holder.find('.designs-options .all-one-design');
			this.designOptions = this.holder.find('.designs-options .box :radio');
			this.relatedProducts = this.holder.find('.related-products .item');
			this.btnClearSubscription = this.holder.find('#clear-subscription');
			this.datepicker = this.holder.find('.datepicker');

			if(!$.cookie('subscriptionSummary')){
				this.summaryObj = {
					'productName': '',
					'productImage': '',
					'productPrice': '',
					'variantId': '',
					'subscriptionId': '',
					'size1': '',
					'size2': '',
					'size3': '',
					'design1': '',
					'design2': '',
					'design3': '',
					'frequency': '',
					'startDate': '',
					'stepIndex': this.activeIndex,
					'checkedItems': ''
				};

				this.datepicker.datepicker().datepicker('setDate', 'today');
			}else{
				this.summaryObj = $.cookie('subscriptionSummary');

				if(this.summaryObj.checkedItems.length > 0){
					for(var i = 0; i < this.summaryObj.checkedItems.length; i++){
						$('#' + this.summaryObj.checkedItems[i]).prop('checked', true).trigger('change');
					}
				}

				this.datepicker.datepicker().datepicker('setDate', this.summaryObj.startDate);
			}

			this.steps.eq(this.activeIndex).addClass(this.options.activeClass);

			this.subscriptionOptions.each(function() {
				var item = $(this),
					hold = item.closest('.option-holder');

				if(item.is(':checked')){
					hold.siblings().removeClass(self.options.selectedClass);
					hold.closest('.option-holder').addClass(self.options.selectedClass);

					if(hold.data('variantId') && hold.data('subscriptionId')){
						self.summaryObj.variantId = hold.data('variantId');
						self.summaryObj.subscriptionId = hold.data('subscriptionId');
					}
				}
			});

			this.designOptions.each(function() {
				var item = $(this),
					hold = item.closest('.box');
					img = hold.find('.image img');

				if(item.is(':checked')){
					img.attr('src', item.data('src'));
				}
			});

			if(this.currStep.find(this.options.subscriptionOptions).length > 0 && this.subscriptionOptions.filter(':checked').length === 0){
				this.btnNext.attr('disabled', true);
			}
		},
		attachEvents: function() {
			var self = this;

			this.btnNext.on('click', function(e){
				e.preventDefault();
				self.nextStep();
			});

			this.btnPrev.on('click', function(e){
				e.preventDefault();
				self.prevStep();
			});

			this.subscriptionOptions.on('change', function(e){
				self.optionsHandler($(this));
			});

			this.sizeOptions.on('change', function(e){
				self.sizeOptionsHandler($(this));
			});

			this.designOptions.on('change', function(e){
				self.designOptionsHandler($(this));
			});

			this.multiSizeOptionsHold.find('li').draggable({
				revert: "invalid",
				containment: "document",
				helper: "clone",
				cursor: "move"
			});

			this.multiSizeHold.find('.variants-holder .frame').droppable({
				accept: this.multiSizeOptionsHold.find('>li'),
				classes: {
					"ui-droppable-active": "ui-state-highlight"
				},
				drop: function(event, ui) {
					$(this).find('.size-value').val($(ui.draggable).find(':radio').val());

					self.stepStateHandler();
				}
			});

			this.btnClearSubscription.on('click', function(e) {
				e.preventDefault();

				self.activeIndex = 0;

				var arr = self.summaryObj.checkedItems;

				if(arr.length > 0){
					for(var i = 0; i < arr.length; i++){
						$('#' + arr[i]).prop('checked', false).closest('.option-holder').removeClass('selected');
					}
				}

				$.removeCookie('subscriptionSummary');

				self.steps.removeClass(self.options.activeClass).eq(self.activeIndex).addClass(self.options.activeClass);
				self.currStep = self.steps.eq(self.activeIndex);

				self.summaryObj = {
					'productName': '',
					'productImage': '',
					'productPrice': '',
					'variantId': '',
					'subscriptionId': '',
					'size1': '',
					'size2': '',
					'size3': '',
					'design1': '',
					'design2': '',
					'design3': '',
					'frequency': '',
					'startDate': '',
					'stepIndex': self.activeIndex,
					'checkedItems': ''
				};

				self.btnPrev.attr('disabled', true);
				self.btnNext.attr('disabled', true);

				self.datepicker.datepicker().datepicker('setDate', 'today');


				self.multiSizeFlag !== null;

				self.sizeNumber.hide();

				setTimeout(function() {
					self.designOptions.filter('.default').prop('checked', true).trigger('change');
					self.stepStateHandler();
				}, 100);

			});

			this.relatedProducts.each(function() {
				var item = $(this),
					btnAdd = item.find('.btn:not(.btn-remove)'),
					btnRemove = item.find('.btn-remove');

				btnAdd.on('click', function(e) {
					e.preventDefault();

					var btn = $(this),
						parent = btn.closest('[data-target]'),
						targetBlock = $('#' + parent.data('target'));

					if(!btn.hasClass('active')){
						btn.addClass('active');
						targetBlock.removeClass('hidden').addClass('visible');
						parent.addClass('added');

						targetBlock.find('.cart-col-price').text(item.find('.price p').text());

						targetBlock.find('.cart-col-frequency select option').prop('selected', false).eq(btn.index()).prop('selected', true);


						var priceCol = targetBlock.find('.cart-col-price'),
							currency = priceCol.text().substr(0, 1),
							qtyInput = targetBlock.find('.qtyValue'),
							totalPrice = targetBlock.find('.cart-col-total'),
							qtyBtns = targetBlock.find('.increaseQty, .decreaseQty');

						function calculatePrice(){
							totalPrice.text(currency + (priceCol.text().substr(1) * qtyInput.val()).toFixed(2));
						}

						calculatePrice();

						targetBlock.find('.btn-remove').one('click', function(e) {
							e.preventDefault();

							btnAdd.removeClass('active');
							targetBlock.removeClass('visible').addClass('hidden');
							parent.removeClass('added');

							self.stepStateHandler();
						});

						qtyInput.on('change', function() {
							calculatePrice();
							self.stepStateHandler();
						});


						qtyBtns.on('click', function() {
							calculatePrice();
							self.stepStateHandler();
						});

						self.stepStateHandler();
					}

				});

				btnRemove.on('click', function(e) {
					e.preventDefault();

					var btn = $(this),
						parent = btn.closest('[data-target]'),
						targetBlock = $('#' + parent.data('target'));

					if(parent.hasClass('added')){
						btnAdd.removeClass('active');
						targetBlock.removeClass('visible').addClass('hidden');
						parent.removeClass('added');
					}

					self.stepStateHandler();
				});
			});
		},
		nextStep: function(){
			if(this.activeIndex < this.steps.length - 1){
				this.activeIndex++;
				this.steps.removeClass(this.options.activeClass);
				this.steps.eq(this.activeIndex).addClass(this.options.activeClass);
				this.currStep = this.steps.eq(this.activeIndex);
				this.currStepOptions = this.currStep.find(this.options.itemOptions);
				this.stepStateHandler();
			}else if(this.activeIndex === this.steps.length - 1){
				this.submitHandler();
			}
		},
		prevStep: function(){
			if(this.activeIndex > 0){
				this.activeIndex--;
				this.steps.removeClass(this.options.activeClass);
				this.steps.eq(this.activeIndex).addClass(this.options.activeClass);
			}

			this.currStep = this.steps.eq(this.activeIndex);
			this.stepStateHandler();
		},
		optionsHandler: function(option) {
			var self = this,
				optionHold = option.closest('.option-holder');

			if(option.is(':radio') || option.is(':checkbox')){
				optionHold.siblings().removeClass(this.options.selectedClass);
				optionHold.addClass(this.options.selectedClass);
				
				if(optionHold.data('variantId') && optionHold.data('subscriptionId')){
					self.summaryObj.variantId = optionHold.data('variantId');
					self.summaryObj.subscriptionId = optionHold.data('subscriptionId');
				}
			}

			if(option.data('multisize') !== undefined){
				this.multiSizeFlag = option.data('multisize');
			}

			this.stepStateHandler();
		},
		sizeOptionsHandler: function(option) {
			option.prop('checked', true);

			this.sizeNumber.text(option.data('quantity')).show();

			if(this.sizeOptions.filter(':checked').length > 0){
				this.sizeNumber.text(this.sizeOptions.filter(':checked').data('quantity')).show();
			}

			this.stepStateHandler();
		},
		designOptionsHandler: function(option) {
			var self = this,
				optionHold = option.closest('.box'),
				img = optionHold.find('.image img');

			if(!this.designAllCheckbox.is(':checked')){
				img.attr('src', option.data('src'));
			}else{
				var optionValue = option.val(),
					optionSrc = option.data('src');

				this.designOptions.prop('checked', false);

				this.designOptions.each(function() {
					if($(this).val() == optionValue){
						$(this).prop('checked', true);
						$(this).closest('.box').find('.image img').attr('src', optionSrc)
					}
				});
			}

			this.stepStateHandler();
		},
		stepStateHandler: function() {
			var self = this,
				requiredOptions = this.currStep.find(this.options.subscriptionOptions),
				singleSizeOptions = this.currStep.find('.size-options:not(.multiple) :radio');
				checkedDesignOptions = this.designOptions.filter(':checked'),
				invalidMultiSizeOptions = this.currStep.find('.size-value').filter(function() {
					return !this.value;
				});
				validMultiSizeOptions = this.currStep.find('.size-value').filter(function() {
					if(this.value){
						return this;
					}
				});

			if(this.activeIndex === 0){
				this.btnPrev.attr('disabled', true);
			}else{
				this.btnPrev.attr('disabled', false);
			}

			if((requiredOptions.length > 0 && requiredOptions.filter(':checked').length === 0) || (singleSizeOptions.length > 0 && singleSizeOptions.filter(':checked').length === 0 && !this.multiSizeFlag) || (this.multiSizeFlag && invalidMultiSizeOptions.length > 0)){
				this.btnNext.attr('disabled', true);
			}else{
				this.btnNext.attr('disabled', false);
			}

			if(this.multiSizeFlag !== null && !this.multiSizeFlag){
				this.multiSizeHold.hide().removeClass('active');

				var checkedSizeOption = this.sizeOptions.filter(':checked');

				this.summaryObj.size1 = checkedSizeOption.val();
				this.summaryObj.size2 = checkedSizeOption.val();
				this.summaryObj.size3 = checkedSizeOption.val();

				this.sizeNumber.text(checkedSizeOption.data('quantity')).show();

			}else{
				var valArr = []

				validMultiSizeOptions.each(function() {
					valArr.push($(this).val());
				});

				if(Math.max.apply(null, valArr) - Math.min.apply(null, valArr) > 1){
					$.fancybox.open($('#popup-warning'));
				}

				var checkedSizeValueItems = self.multiSizeHold.find('.size-value')/*.filter(':checked')*/;

				this.multiSizeHold.show().addClass('active');

				self.summaryObj.size1 = checkedSizeValueItems.eq(0).val();
				self.summaryObj.size2 = checkedSizeValueItems.eq(1).val();
				self.summaryObj.size3 = checkedSizeValueItems.eq(2).val();
			}

			this.summaryObj.productName = this.subscriptionOptions.filter('.subscription-name:checked').val();
			this.summaryObj.productImage = this.subscriptionOptions.filter('.subscription-name:checked').closest('.option-holder').data('image');
			this.summaryObj.productPrice = this.subscriptionOptions.filter('.subscription-name:checked').closest('.option-holder').data('price');

			this.summaryObj.design1 = checkedDesignOptions.eq(0).val();
			this.summaryObj.design2 = checkedDesignOptions.eq(1).val();
			this.summaryObj.design3 = checkedDesignOptions.eq(2).val();
			this.summaryObj.frequency = this.frequencyOptions.filter(':checked').val();
			this.summaryObj.startDate = this.datepicker.val();

			$('#product-name').text(this.summaryObj.productName);
			$('#product-price, #product-total-price').text(this.summaryObj.productPrice);
			$('#product-image').attr('src', this.summaryObj.productImage).attr('alt', this.summaryObj.productName);
			$('#product-frequency').text(this.summaryObj.frequency);

			$('#product-size-1').text(self.summaryObj.size1);
			$('#product-size-2').text(self.summaryObj.size2);
			$('#product-size-3').text(self.summaryObj.size3);

			$('#product-design-1').text(self.summaryObj.design1);
			$('#product-design-2').text(self.summaryObj.design2);
			$('#product-design-3').text(self.summaryObj.design3);

			window.location.hash = '#' + this.currStep.attr('id');

			var subTotalPrice = 0,
				currency = $('#product-total-price').text().substr(0, 1);

			$('.cart-table tbody tr:not(.hidden)').each(function() {
				var price = parseFloat($(this).find('.cart-col-total').text().substr(1));

				subTotalPrice += price;
			});

			$('#cart-subtotal').text(currency + subTotalPrice.toFixed(2));

			this.summaryObj.stepIndex = this.activeIndex;

			var checkedItemsArr = [];

			this.holder.find('input:checked').each(function() {
				checkedItemsArr.push($(this).attr('id'));
			});

			this.summaryObj.checkedItems = checkedItemsArr;

			$.cookie('subscriptionSummary', this.summaryObj);
		},
		submitHandler: function() {
			var self = this;
			
			var element_id = '#btn-subscription-checkout';

			var product_variant_id = this.summaryObj.variantId;
			var product_quantity = 1;
			var product_interval_frequency = this.summaryObj.frequency;
			var product_interval_unit = 'Weeks';
			var product_start_date = this.summaryObj.startDate;
			var product_design_1 = this.summaryObj.design1;
			var product_design_2 = this.summaryObj.design2;
			var product_design_3 = this.summaryObj.design3;
			var product_size_1 = this.summaryObj.size1;
			var product_size_2 = this.summaryObj.size2;
			var product_size_3 = this.summaryObj.size3;
			var product_subscription_id = '195426';

			//
			var myshopify_domain = this.btnNext.data('store');
			var customer_id = this.btnNext.data('customer_id');
			var customer_email = this.btnNext.data('customer_email');
			var customer_param = false;


			if (customer_id && customer_email) {
				customer_param = 'customer_id=' + customer_id + '&customer_email=' + customer_email;
			}

			function reChargeGetCookie(name) {
				return (document.cookie.match('(^|; )' + name + '=([^;]*)')||0)[2];
			}

			addItemToCart(product_variant_id, product_quantity, product_interval_frequency, product_interval_unit, product_subscription_id);

			function addItemToCart(variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id, product_start_date, product_design_1, product_design_2, product_design_3, product_size_1, product_size_2, product_size_3) {

				data = {
					"quantity": quantity,
					"id": variant_id,
					"properties[shipping_interval_frequency]": shipping_interval_frequency, 
					"properties[shipping_interval_unit_type]": shipping_interval_unit_type,
					"properties[shipping_start_date]": product_start_date,
					"properties[product_design_bag_1]": product_design_1,
					"properties[product_design_bag_2]": product_design_2,
					"properties[product_design_bag_3]": product_design_3,
					"properties[product_size_bag_1]": product_size_1,
					"properties[product_size_bag_2]": product_size_2,
					"properties[product_size_bag_3]": product_size_3,
					"properties[subscription_id]": subscription_id
				}

				$.ajax({
					type: 'POST',
					url: '/cart/add.js',
					data: data,
					dataType: 'json',
					success: function() {
						// Build the Checkout URL
						var token = reChargeGetCookie('cart');
						try {
							// Cross-domain tracking with Google Analytics
							var ga_linker = ga.getAll()[0].get('linkerParam');
						} catch (e) {
							// 'ga' is not available
							var ga_linker = '';
						}
						// Customer email address for use in the Checkout URL
						var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' + myshopify_domain + '&cart_token=' + token + '&' + ga_linker + '&' + customer_param

						window.location.href = checkout_url; 
					}
				});
			}
		}
	};

	// detect touch devices
	var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

	// jQuery plugin interface
	$.fn.subscriptionSteps = function(opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		return this.each(function() {
			var $holder = jQuery(this);
			var instance = $holder.data('SubscriptionSteps');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				$holder.data('SubscriptionSteps', new SubscriptionSteps($.extend({
					holder: this
				}, opt)));
			} else if (typeof method === 'string' && instance) {
				if (typeof instance[method] === 'function') {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};
}(jQuery));